import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { consentStatus, grantConsent, denyConsent } from "@/lib/visitor-tracking";

export const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (consentStatus() === "unknown") setVisible(true);
  }, []);

  const accept = () => {
    grantConsent();
    setVisible(false);
  };
  const reject = () => {
    denyConsent();
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          role="dialog"
          aria-label="Cookie consent"
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ duration: 0.25, ease: "easeOut" }}
          className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:max-w-md z-[60]"
        >
          <div className="rounded-sm border border-foreground/25 bg-card/95 backdrop-blur-xl shadow-lg p-5">
            <p className="text-sm font-semibold text-foreground mb-1">Analytics cookies</p>
            <p className="text-sm text-muted-foreground leading-relaxed mb-4">
              We use a single first-party cookie to understand how our site is used and to recognise
              you when you return via a link we sent. No third-party trackers, no ad networks.{" "}
              <Link to="/privacy-policy" className="text-primary hover:underline">Privacy policy</Link>.
            </p>
            <div className="flex gap-2">
              <Button
                onClick={reject}
                variant="outline"
                className="flex-1 h-10"
              >
                Reject
              </Button>
              <Button
                onClick={accept}
                className="flex-1 h-10"
              >
                Accept
              </Button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
